import axios from 'axios';
import xhrRoutes from '../routes/xhr';
import Translator from '../translator';
import stringifyObject from '../../helpers/stringify-object';
import commentTextAreas from './comment-textareas';

const fn = {
  classButtonDisabled: 'card__comments__btn--disabled',
  init: () => {
    const commentEdits = document.querySelectorAll('.js-comment-edit');

    if (!commentEdits.length) {
      return;
    }

    [].forEach.call(commentEdits, (commentEdit) => {
      commentEdit.addEventListener('click', (e) => {
        e.preventDefault();

        const commentId = commentEdit.getAttribute('data-comment-edit-id');

        if (!commentId) {
          return;
        }

        const commentText = document.querySelector(`[data-comment-text-id="${commentId}"]`);

        if (!commentText) {
          return;
        }

        const commentEditTemplate = document.querySelector(`[data-script-id="${commentId}"]`);

        if (!commentEditTemplate) {
          return;
        }

        commentText.innerHTML = commentEditTemplate.innerHTML;

        const commentTextArea = commentText.querySelector('.js-comment-textarea-edit');
        commentTextArea.focus();
        commentTextArea.setSelectionRange(commentTextArea.value.length, commentTextArea.value.length);
        commentTextArea.style.minHeight = `${commentTextArea.scrollHeight}px`;
        commentTextAreas.init('.js-comment-textarea-edit');

        const commentActions = document.querySelector(`[data-comment-actions="${commentId}"]`);
        commentActions.style.display = 'none';

        app.msnry.inst.layout();

        const commentTextAreaValue = commentTextArea.value;
        const commentCancel = commentText.querySelector('.js-comment-cancel');
        commentCancel.addEventListener('click', (e) => {
          e.preventDefault();

          commentActions.style.display = 'block';
          commentText.innerHTML = `<p>${commentTextAreaValue}</p>`;
          app.msnry.inst.layout();
        });

        const commentButton = commentText.querySelector('.js-comment-button');
        commentButton.addEventListener('click', () => {
          if (commentButton.classList.contains(fn.classButtonDisabled)) {
            return;
          }

          commentCancel.style.display = 'none';
          commentButton.classList.add(fn.classButtonDisabled);

          const route = xhrRoutes.comment.editComment;
          route.params.comment_id = commentId;
          route.params.comment = commentTextArea.value;

          axios.post(route.url, stringifyObject(route.params))
            .then((response) => {
              if (response.data.status === 'fail') {
                fn.showNotification('error', Translator.trans('api.error.fail'));
                commentCancel.style.display = 'block';
                commentButton.classList.remove(fn.classButtonDisabled);
              } else {
                fn.showNotification('success', Translator.trans('api.community.comment.editted'));
              }

              fn.resetScriptTemplate(commentEditTemplate, commentTextArea.value);
              commentActions.style.display = 'block';
              commentText.innerHTML = `<p>${commentTextArea.value}</p>`;
              app.msnry.inst.layout();
            })
            .catch((error) => {
              console.log(error);
            })
            .then(() => {
            });
        });
      });
    });
  },
  showNotification: (type, message) => {
    const notification = document.createElement('div');
    notification.classList.add('notification');
    notification.classList.add(`notification--${type}`);
    notification.innerHTML = message;
    document.body.appendChild(notification);
  },
  resetScriptTemplate: (template, textAreaValue) => {
    template.innerHTML = `<textarea class="card__comment__edit__textarea js-comment-textarea-edit" placeholder="${Translator.trans('api.community.comment.textarea.placeholder')}">${textAreaValue}</textarea>`;
    template.innerHTML += `<button class="btn card__comments__btn js-comment-button">${Translator.trans('api.community.comment.edit')}</button>`;
    template.innerHTML += `<a class="card__comment__action card__comment__action--edit card__comment__action--cancel js-comment-cancel" href="#">${Translator.trans('api.community.comment.cancel')}</a>`;
  },
};

export default fn;
